function caramellaSafeExecute(fn) {
	
	jQuery(window).on("load", function () {
		if (typeof fn === 'function') {
			// console.log(fn + ' was executed on load');
			fn();
		}
	});

	jQuery(document).on('tinymce-editor-init ajaxSuccess', function () {
		if (typeof fn === 'function') {
			// console.log(fn + ' was executed on tinymce-editor-init ajaxSuccess');
			fn();
		}
	});
}

window.caramellaSafeExecute = caramellaSafeExecute;	//	declaring it globally so we can use it without having to import again

